import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { HiCheckCircle } from '@react-icons/all-files/hi/HiCheckCircle';
import { Form, Image } from 'react-bootstrap';
import { useAuth } from '../auth/Auth';
import { nextChallengeViewModel } from '../views/next_challenge/next.challenge.viewmodel';
import { CHALLENGE_ROUTE, EVENT_ROUTE, NEXT_CHALLENGE_ROUTE, SPECIAL_CHALLENGE_ROUTE } from '../../constants/routes.constants';
import acceptedChallenge_img from '../../assets/logo/logo-53x53.svg';
import defaultProfilePic from '../../assets/profile/default-profile-guardian.svg';
import EventEmitter from '../../utils/events';
import OptimizeSignup from '../views/onboarding/signup_popups/OptimizeSignup';

const SideBarAcceptedChallenges = (props) => {
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();
  const { dependent, guardian, school, fetchAPI } = useAuth();
  const [acceptedChallenge, setAcceptedChallenge] = useState([]);

  const fetchAcceptedChallenges = () => {
    let params = { dependent_id: dependent.id };
    fetchAPI(
      nextChallengeViewModel.getMyRoomChallenges,
      'working',
      params
    )
      .then((data) => {
        setAcceptedChallenge(data.challengeList)
      })
      .catch((err) => console.log(err));
  };

  const redirectPage = () => {
    if (dependent && !guardian) {
      history.push(NEXT_CHALLENGE_ROUTE)
    }
    else {
      if (!dependent && !school) {
        setShowModal(true);
        localStorage.setItem('kids_login_location', window.location.href)
      }
    }
  }

  const fetchAcceptedChallengesFun = (data) => {
    if (dependent && !guardian) {
      fetchAcceptedChallenges();
    }
  }


  useEffect(() => {
    fetchAcceptedChallengesFun();
    EventEmitter.subscribe('accept_challenge', fetchAcceptedChallengesFun)
    return function () {
      EventEmitter.unsubscribe('accept_challenge')
    }
  }, []);

  const onChallengeClick = (id, index, challenge) => {
    if (dependent && !guardian) {
      const isEvent = challenge?.is_event ? 'event' : challenge?.special_camp?.id ? 'special' : 'challenge'
      let path;
      let encodeQuery;
      if (isEvent === 'challenge') {
        path = CHALLENGE_ROUTE
        encodeQuery = btoa(`{"id":${id}, "slug":"challenge"}`)
      }
      if (isEvent === 'special') {
        path = SPECIAL_CHALLENGE_ROUTE
        encodeQuery = btoa(`{"id":${id}, "slug":"special-challenge"}`)
      }
      if (isEvent === 'event') {
        path = EVENT_ROUTE
        encodeQuery = btoa(`{"id":${id}, "slug":"event"}`)
      }
      history.push({
        pathname: path,
        search: `?encrypt=${encodeQuery}`
      })
      window.scrollTo(0, 0);
    }
    else {
      setShowModal(true);
      localStorage.setItem('kids_login_location', window.location.href)
    }
  }

  return (
    <div className='accepted-challenges hide-on-toggle'>
      <div className='accepted-challenges-head'>
        Accepted Challenges
      </div>
      <div className='accepted-challenges-body'>
        {acceptedChallenge.length === 0 ?
          <div className="no-challenges">
            No Challenges
          </div>
          : ''}
        <div className="no-challenges" role='button'>
          <ul>
            {acceptedChallenge.map((challenge, index) => (
              <li key={index} onClick={() => onChallengeClick(challenge.id, index, challenge)} >
                {challenge.created_by?.is_superuser === true ?
                  <Image src={acceptedChallenge_img} />
                  : challenge.created_by?.picture_url ?
                    <Image src={challenge.created_by?.picture_url} />
                    : <Image src={defaultProfilePic} />
                }
                {challenge.title} <span className='check-list-icon'><HiCheckCircle /></span></li>
            ))}
          </ul>
        </div>

        {props.isNewChallengesButton && acceptedChallenge.length < 3 &&
          <div className='new-challenges' role="button" onClick={redirectPage}>
            <span className='plus-ic'>+</span>
            <p>
              <strong>Let's start working on new Challenges!</strong> <br />
              You can choose up to {3 - acceptedChallenge.length} Challenges.
            </p>
          </div>
        }

      </div>
      {/* <GuestRedirectVerification showModal={showModal} setShowModal={setShowModal} /> */}
      <OptimizeSignup showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
}

export default SideBarAcceptedChallenges;
